import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { StyledDivider } from '@/components/common/StyledDivider';
import { DetailSidebarContent } from '@/components/map/details/DetailSidebarContent';
import { ParkingFacilityDetailContent } from '@/components/map/details/content/ParkingFacilityDetailContent';
import { ParkingFacilityDetailTable } from '@/components/map/details/table/ParkingFacilityDetailTable';
import { I18N_DE } from '@/i18n/de';
import {
  backendApiParkingDataFindAllLatestParkingFacilityDataOptions,
  backendApiParkingFacilitiesFindOneOptions,
} from '@/modules/api/backend/@tanstack/react-query.gen';
import { MapLayer } from '@/types/MapLayer';

export const Route = createFileRoute('/_public/_map/_sidebar/parking-facilities/$parkingFacilityId')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const { parkingFacilityId } = Route.useParams();

  const { data: facility } = useSuspenseQuery({
    ...backendApiParkingFacilitiesFindOneOptions({
      path: { parkingFacilityId },
      query: { organization: true },
    }),
  });

  const { data: parkingData } = useQuery({
    ...backendApiParkingDataFindAllLatestParkingFacilityDataOptions(),
    select: (data) => data.find((item) => item.id === parkingFacilityId),
  });

  return (
    <DetailSidebarContent
      mapLayer={MapLayer.PARKING_FACILITY}
      subtitle={facility?.facilityType ? I18N_DE.FacilityType[facility.facilityType] : undefined}
      title={facility.name}
    >
      <ParkingFacilityDetailContent data={parkingData} facility={facility} />

      <StyledDivider />

      <ParkingFacilityDetailTable facility={facility} />
    </DetailSidebarContent>
  );
}
